import AxiosBase from "@services/middlewares/AxiosBase";
import Vue from 'vue';

export default function ({next}) {
  const app = new Vue;
  app.$store.commit('setting/setAuthType', 'hotelAuth')
  return AxiosBase({next, authKey: 'hotelAuth'})
}
